/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Action_Export_CsvInputs */

const en_action_export_csv = /** @type {(inputs: Action_Export_CsvInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Export Data`)
};

const es_action_export_csv = /** @type {(inputs: Action_Export_CsvInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportar Datos`)
};

const fr_action_export_csv = /** @type {(inputs: Action_Export_CsvInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exporter les données`)
};

const de_action_export_csv = /** @type {(inputs: Action_Export_CsvInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Daten exportieren`)
};

const id_action_export_csv = /** @type {(inputs: Action_Export_CsvInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ekspor Data`)
};

/** @type {(inputs: Action_Export_CsvInputs) => LocalizedString} */
const ja_action_export_csv = en_action_export_csv;

/** @type {(inputs: Action_Export_CsvInputs) => LocalizedString} */
const zh_action_export_csv = en_action_export_csv;

/** @type {(inputs: Action_Export_CsvInputs) => LocalizedString} */
const ar_action_export_csv = en_action_export_csv;

/** @type {(inputs: Action_Export_CsvInputs) => LocalizedString} */
const it_action_export_csv = en_action_export_csv;

/** @type {(inputs: Action_Export_CsvInputs) => LocalizedString} */
const ru_action_export_csv = en_action_export_csv;

/** @type {(inputs: Action_Export_CsvInputs) => LocalizedString} */
const pt_action_export_csv = en_action_export_csv;

/** @type {(inputs: Action_Export_CsvInputs) => LocalizedString} */
const ko_action_export_csv = en_action_export_csv;

/**
* | output |
* | --- |
* | "Export Data" |
*
* @param {Action_Export_CsvInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const action_export_csv = /** @type {((inputs?: Action_Export_CsvInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Action_Export_CsvInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_action_export_csv(inputs)
	if (locale === "es") return es_action_export_csv(inputs)
	if (locale === "fr") return fr_action_export_csv(inputs)
	if (locale === "de") return de_action_export_csv(inputs)
	if (locale === "ja") return ja_action_export_csv(inputs)
	if (locale === "zh") return zh_action_export_csv(inputs)
	if (locale === "ar") return ar_action_export_csv(inputs)
	if (locale === "id") return id_action_export_csv(inputs)
	if (locale === "it") return it_action_export_csv(inputs)
	if (locale === "ru") return ru_action_export_csv(inputs)
	if (locale === "pt") return pt_action_export_csv(inputs)
	return ko_action_export_csv(inputs)
});